import FinanceComparisonView from 'components/organisms/finance-comparison/FinanceComparisonView'
import React from 'react'

const FinanceComparison = () => {
  return (
    <FinanceComparisonView />
  )
}

export default FinanceComparison